import { render, staticRenderFns } from "./PlasiyerUrunSatis.vue?vue&type=template&id=545693a3&scoped=true"
import script from "./PlasiyerUrunSatis.vue?vue&type=script&lang=js"
export * from "./PlasiyerUrunSatis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545693a3",
  null
  
)

export default component.exports